<template>
    <div class="trial-end-clock__container">
        <div class="header__wrapper">
            <SaasIcon icon="svgLogoSellsyText" width="118" height="28" class="sellsy-logo" />
        </div>

        <div class="trial-end-clock-content__container">
            <img
                :src="`/ressources/logged/img/illustrations/${imgSrc}.svg`"
                :width="210"
                :height="160"
            />

            <h1 class="typographies-display-large content-title">
                {{ title }}
            </h1>

            <p class="typographies-paragraph-x-large-regular content-subtitle__wrapper">
                <span v-for="(subtitle, index) in subtitles" :key="index">
                    {{ subtitle }}
                </span>
            </p>

            <div class="content__wrapper">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitles: {
            type: Array,
            default: () => [],
        },
        imgSrc: {
            type: String,
            default: 'elapsed-time-green',
        },
    },
};
</script>

<style scoped lang="scss">
.trial-end-clock {
    &-content__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        max-width: 920px;
        margin: 0 auto;
    }
    &__container {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
}

.header__wrapper {
    margin: var(--spacing-1) var(--spacing-1) 0;

    .sellsy-logo {
        color: var(--colors-component-background-illustration-brand-secondary-blue);
    }
}

.content {
    &__wrapper {
        display: flex;
        flex-direction: column;
        place-items: center;
        justify-content: center;
        gap: var(--spacing-4);
        margin-top: var(--spacing-5);
        color: var(--colors-common-text-standard-caption);
    }

    &-subtitle__wrapper {
        margin: 0;
        color: var(--colors-common-text-subtle-default);
    }

    &-title {
        margin: var(--spacing-5) 0 var(--spacing-3);
        width: max-content;
        color: var(--colors-common-text-brand-secondary-blue);
    }
}
</style>
<style lang="scss">
#sellsy_app #contentDiv:has(.trial-end-clock__container) {
    background-color: var(--colors-common-background-app);
}
</style>
